import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  Grid,
  InputAdornment,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import RowsPerPage from "../models/inputs/RowsPerPage";
import moment from "moment";
import CachedIcon from "@material-ui/icons/Cached";
import clsx from "clsx";
import { presentFormatedData } from "../functionalComponents/dataFormatFunctions";
import CustomDatePickerMui from "../models/inputs/DateInput";
import PaginationInput from "../models/pagination/PaginationInput";
import Actions from "./Actions";
import { ChevronRight } from "@material-ui/icons";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ProposeCounterOfferDialog from "./ProposeCounterOfferDialog";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import axios from "axios";
import { appUrl } from "../../../../../utils/config";
import BackDropLoading from "../models/BackDrop";
import { useDispatch, useSelector } from "react-redux";
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from "../../../containers/actions/types";
import StyledButton from "../../../../common/models/Button";
import CloseIcon from "@material-ui/icons/Close";
import DraggableDialogTable1 from "./DraggableDialogTable1";
import ElectronicSignatureValidation from "./ElectronicSignatureValidation";
import jwtDecode from "jwt-decode";
import StyledDialog from "../../../../common/models/Dialog";
import ChatBox from "./ChatBox";
import CancelIcon from "@material-ui/icons/Cancel";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import { getFeaturesAccess } from "../../../containers/actions/common/accessControl";

const useStyles = makeStyles((theme) => ({
  backBtn: {
    display: "flex",
    alignSelf: "center",
    padding: "8px",
    cursor: "pointer",
    textTransform: "none",
    "&:hover": {
      background: "transparent",
      borderBottom: "2px solid black",
    },
  },
  icon: {
    paddingLeft: "1rem",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 0,
      fontSize: "1.7rem",
    },
  },
  backGrid: {
    display: "flex",
    justifyContent: "flex-start",
  },
  upload: {
    background:
      "transparent linear-gradient(251deg, #173072 0%, #301232 100%) 0% 0% no-repeat padding-box",
    color: "white",
    textTransform: "none",
    borderRadius: "2rem",
    padding: "5px 20px",
    "&:hover": {
      backgroundColor: "green",
      color: "white",
    },
  },
  clickableTextSty: {
    maxWidth: "250px",
    "&:hover": {
      textDecoration: "underline",
      color: "#2196F3",
      cursor: "pointer",
    },
  },
  button: {
    borderRadius: "50px", // Rounded corners for pill shape
    border: "1px solid #000", // Border with black color
    padding: "5px 15px", // Padding for buttons
    fontWeight: 500,
    width: "100%",
    color: "#000", // Text color black
    backgroundColor: "#fff", // Background white
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#f4f4f4", // Slightly darker background on hover
    },
  },
  searchFld: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  flxEd: {
    justifyContent: "flex-end",
  },
  padR20: {
    paddingRight: 20,
    [theme.breakpoints.down("xs")]: {
      paddingRight: 0,
    },
  },
  refreshSty: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  selectFilterSty: {
    fontSize: "0.875rem",
    "& .MuiSelect-select": {
      paddingTop: "1rem",
      paddingBottom: "1rem",
    },
  },
  styledBtn: {
    textTransform: "none",
    borderRadius: "2rem",
  },
  saveEditButton: {
    backgroundColor: "#f4511e",
    color: "#fff",
    borderRadius: "1rem",
    "&:hover": {
      backgroundColor: "#ff5722",
      color: "#fff",
      borderRadius: "1rem",
    },
  },
  cancelEditButton: {
    backgroundColor: "#B4B4B4",
    color: "#fff",
    borderRadius: "1rem",
    "&:hover": {
      backgroundColor: "#B4B4B4",
      color: "#fff",
      borderRadius: "1rem",
    },
  },
  textField: {
    "& .MuiOutlinedInput-input": {
      padding: "10px 10px",
    },
  },
  dialogContent: {
    textAlign: "center",
    padding: "30px 36px 24px 36px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
    fontSize: "80px",
  },
  dialogActions: {
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  dialogPaper: {
    borderRadius: "1rem",
  },
  noButton: {
    backgroundColor: "transparent",
    color: "black",
    border: "1px solid black",
    paddingLeft: "3rem",
    paddingRight: "3rem",
    textTransform: "none",
    borderRadius: "2rem",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
      border: "1px solid #FFF",
    },
  },
  clearText: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    textDecoration: "underline",
    "&:hover": {
      color: "#173072",
      textDecoration: "underline",
    },
  },
}));

const renderPOLineStatusButton = (statusID, statusText) => {
  let color;
  switch (statusID) {
    case 21: //"Created"
      color = "#B4B4B4"; // Bright orange for Ongoing
      break;
    case 23: //"Under confirmation":
      color = "#E78A00"; // Green for Completed
      break;
    case 22: //"Shared with CMO":
      color = "#2196F3"; // Grey for Awaiting Start
      break;
    case 25: //"Confirmed":
      color = "#329429"; // Grey for Awaiting Start
      break;
    case 27: //"Approved":
      color = "#329429"; // Grey for Awaiting Start
      break;
    case 24: //"Rejected By CMO":
      color = "#FF0000";
      break;
    default:
      color = "#1E1E1E";
  }
  return (
    <Typography
      variant="body1"
      style={{
        textAlign: "center",
        padding: "0.25rem",
        borderRadius: "0.45rem",
        fontSize: "0.875rem",
        color: "white",
        backgroundColor: color,
        border: `2px solid ${color}`,
        whiteSpace: "nowrap",
      }}
    >
      {statusText}
    </Typography>
  );
};

const renderPOStatusButton = (statusID, statusText) => {
  let color;
  switch (statusID) {
    case 21: //"Created"
      color = "#B4B4B4"; // Bright orange for Ongoing
      break;
    case 23: //"Under confirmation":
      color = "#E78A00"; // Green for Completed
      break;
    case 22: //"Shared with CMO":
      color = "#2196F3"; // Grey for Awaiting Start
      break;
    case 25: //"Confirmed":
      color = "#707070"; // Grey for Awaiting Start
      break;
    case 27: //"Approved":
      color = "#329429"; // Grey for Awaiting Start
      break;
    case 24: //"Rejected By CMO":
      color = "#FF0000";
    case 26: //"Rejected By CMO":
      color = "#EC6535";
      break;
    default:
      color = "#1E1E1E";
  }
  return (
    <Typography
      variant="body1"
      style={{
        textAlign: "center",
        padding: "0.25rem",
        borderRadius: "0.45rem",
        fontSize: "0.875rem",
        color: "white",
        backgroundColor: color,
        border: `2px solid ${color}`,
        whiteSpace: "nowrap",
      }}
    >
      {statusText}
    </Typography>
  );
};

const POLineItemDashboard = () => {
  const location = useLocation();
  const SLDetailsData = location.state?.data;
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const tokenData = jwtDecode(localStorage.getItem("authToken"));

  const [poLineStatusArray, setPOLineStatusArray] = useState([]);
  const [selectProduct, setProduct] = useState("all");
  const [poLineStatus, setPOLineStatus] = useState("0");
  const [noRowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [status, setStatus] = useState(false);
  const [POData, setPOData] = useState(null);
  const [POLineList, setPOLineList] = useState([]);
  const [approvalWorkflowDetails, setApprovalWorkflowDetails] = useState([]);

  const [editableRow, setEditableRow] = useState(null);
  const [error, setError] = useState("");

  const [pageLoading, setPageLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(true);

  const [successDialogBox, setSuccessDialogBox] = useState({
    openDialogBox: false,
    dialogBoxType: "",
  });

  const [proposeOfferDialog, setProposeOfferDialog] = useState({
    openDialogBox: false,
    data: null,
  });

  const [confirmPOApprove, setConfirmPOApprove] = useState({
    confirmDialogBox: false,
    approveWorkflow: false,
  });

  const [electronicSignatureDialog, setElectronicSignatureDialog] = useState({
    electronicSignatureValidation: false,
    electronicSignatureSuccess: false,
    data: null,
  });

  const [approveRejectWorkFlowSuccess, setAppoveRejectWorkflowSuccess] =
    useState({
      dialogBox: false,
      type: "",
    });

  const originalPOLineList = useRef();

  const screenAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.screensAccess?.data.poLineDashboard
  );

  const featuresAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.featuresAccess.poLineDashboardFeatures
  );

  useEffect(() => {
    if (screenAccess?.screenAccess && !featuresAccess)
      dispatch(
        getFeaturesAccess(screenAccess?.screenId, "poLineDashboardFeatures")
      ); //10 is DS screen ID
    // We can pick up DS screen Id from access screensAccess.data.deliverySchedule.screenId
  }, [dispatch, screenAccess, featuresAccess]);

  const handleBack = () => {
    history.push(
      `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/purchaseorders`,
      {
        fiters: location.state?.fiters,
      }
    );
  };

  const handleViewHistory = () => {
    history.push(
      `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/purchaseorders/purchaseOrderAuditReport`,
      { data: SLDetailsData }
    );
  };

  let productList = SLDetailsData?.SLDetails ? SLDetailsData?.SLDetails : [];

  const handleSelectProduct = (val) => {
    setCurrentPage(1);
    setProduct(val.target.value);
    setEditableRow(null);
  };

  const handleSelectPOLineStatus = (val) => {
    setCurrentPage(1);
    setPOLineStatus(val.target.value);
    setEditableRow(null);
  };

  const handleSetRows = (event) => {
    setRowsPerPage(event.target.value);
    setCurrentPage(1);
    setEditableRow(null);
  };

  const handleEditClick = (index) => {
    setEditableRow(index);
  };

  const handleSaveClick = (row) => {
    setEditableRow(null);
    handleUpdatePOLineDetails("poLineEditFlag", row, []);
  };

  const handleInputChange = (index, field, value) => {
    // Create a deep copy of POLineList to avoid accidental mutation
    const updatedData = POLineList.map((item, idx) =>
      idx === index ? { ...item, [field]: value } : item
    );

    // Handle date fields explicitly
    if (
      field === "requestedDeliveryDate" ||
      field === "committedDeliveryDate"
    ) {
      updatedData[index][field] =
        value != null && value.format
          ? value.format("YYYY-MM-DDTHH:mm")
          : value;
    } else {
      updatedData[index][field] = value;
    }

    // Update state
    setPOLineList(updatedData);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setEditableRow(null);
  };

  const handleOpenProposeOfferDialog = (lineItem) => {
    setProposeOfferDialog({
      openDialogBox: true,
      data: lineItem,
    });
  };

  const handleCloseProposeOfferDialog = () => {
    setProposeOfferDialog({
      openDialogBox: false,
      data: null,
    });
  };

  const isSameDate = (date1, date2) => {
    const d1 = new Date(date1).toISOString().split("T")[0]; // Extract YYYY-MM-DD
    const d2 = new Date(date2).toISOString().split("T")[0];
    return d1 === d2;
  };

  const handleUpdatePOLineDetails = (
    flag,
    SLDetails,
    approvalWorkFlowDetails
  ) => {
    setEditableRow(null);
    let selectedLineitem = null;
    if (SLDetails) {
      selectedLineitem =
        originalPOLineList.current.filter(
          (val) => val.schrockenSLID === SLDetails.schrockenSLID
        ).length > 0
          ? originalPOLineList.current.filter(
            (val) => val.schrockenSLID === SLDetails.schrockenSLID
          )[0]
          : {};
    }

    let data = {
      vendorMosymphonyID: POData?.vendorMosymphonyID,
      scheduleAgreementStatusID: POData?.scheduleAgreementStatusID,
      scheduleAgreementStatusText: POData?.scheduleAgreementStatusText,
      schrockenSAID: POData?.schrockenSAID,
      scheduleAgreementNumber: POData?.scheduleAgreementNumber,
      vendorName: POData?.vendorName,
      sponsorName: POData?.sponsorName,
      productsList: SLDetailsData?.SLDetails ? SLDetailsData?.SLDetails : [],
      poLineEditFlag:
        flag === "poLineEditFlag" ||
          flag === "acceptOfferFlag" ||
          flag === "rejectOfferFlag"
          ? true
          : false,
      acceptOfferFlag: flag === "acceptOfferFlag" ? true : false,
      rejectOfferFlag: flag === "rejectOfferFlag" ? true : false,
      approveFlag: flag === "approveFlag" ? true : false,
      shareWithCMOFlag: flag === "shareWithCMOFlag" ? true : false,
      confirmedFlag: flag === "confirmedFlag" ? true : false,
      SLDetails: SLDetails
        ? {
          ...SLDetails,
          changeInQty:
            localStorage.collabType !== "CMO"
              ? SLDetails.requestedQuantity ===
                selectedLineitem.requestedQuantity
                ? false
                : true
              : SLDetails.committedQuantity ===
                selectedLineitem.committedQuantity
                ? false
                : true,

          changeInDate:
            localStorage.collabType !== "CMO"
              ? SLDetails.requestedDeliveryDate &&
                selectedLineitem.requestedDeliveryDate
                ? isSameDate(
                  SLDetails.requestedDeliveryDate,
                  selectedLineitem.requestedDeliveryDate
                )
                  ? false
                  : true
                : SLDetails.requestedDeliveryDate
                  ? true
                  : false
              : SLDetails.committedDeliveryDate &&
                selectedLineitem.committedDeliveryDate
                ? isSameDate(
                  SLDetails.committedDeliveryDate,
                  selectedLineitem.committedDeliveryDate
                )
                  ? false
                  : true
                : SLDetails.committedDeliveryDate
                  ? true
                  : false,
          markedForDelete: flag === "itemDeleteFlag" ? true : false,
        }
        : null,
      approvalWorkFlowDetails: approvalWorkFlowDetails
        ? approvalWorkFlowDetails
        : [],
    };

    dispatch({
      type: OPEN_BACKDROP,
    });

    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updatePODetails`,
        data
      )
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          setSuccessDialogBox({
            openDialogBox: true,
            dialogBoxType:
              flag === "poLineEditFlag"
                ? "updateLineItem"
                : flag === "acceptOfferFlag"
                  ? "AcceptOffer"
                  : flag === "rejectOfferFlag"
                    ? "RejectOffer"
                    : flag === "shareWithCMOFlag"
                      ? "shareWithCMO"
                      : flag === "itemDeleteFlag"
                        ? "deleteLineItem"
                        : flag === "approveFlag"
                          ? "approvePO"
                          : "",
          });
        } else {
          dispatch({
            type: DESTROY_BACKDROP,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        console.log(err);
      });
  };

  const handleRefresh = () => {
    setEditableRow(null);
    let data = {
      schrockenSAID: SLDetailsData?.schrockenSAID,
      fgMaterialCode: selectProduct === "all" ? null : selectProduct,
      scheduleLineStatusID: parseInt(poLineStatus),
      pageNumber: currentPage,
      pageSize: noRowsPerPage,
    };
    setTableLoading(true);

    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOLineItems`,
        data
      )
      .then((res) => {
        if (res.data.status) {
          const fetchedData = res.data.data.SLDetails.map((item) => ({
            ...item,
          }));
          originalPOLineList.current = fetchedData; // Assign only after copying
          setPOLineList(fetchedData); // Update POLineList state
          setPOData(res.data.data.SADetails);
          setStatus(res.data.status);
          setApprovalWorkflowDetails(
            res.data.data.approvalWorkFlowData
              ? res.data.data.approvalWorkFlowData
              : []
          );
          setTotalPages(res.data.data.numberOfPages);
          setTableLoading(false);
          setPageLoading(false);
        } else {
          setStatus(false); // If API response is not successful
        }
      })
      .catch((err) => {
        console.log(err);
        setStatus(false);
      })
      .finally(() => {
        setTableLoading(false);
        setPageLoading(false);
      });
  };

  const handleApproveRejectWorkflow = (type) => {
    setElectronicSignatureDialog({
      electronicSignatureValidation: true,
      electronicSignatureSuccess: false,
      data: {
        ...POData,
        decision: type,
      },
    });
  };

  const handleUpdateApproveRejectPOWorkflow = (type) => {
    let data = {
      vendorMosymphonyID: POData?.vendorMosymphonyID,
      scheduleAgreementStatusID: POData?.scheduleAgreementStatusID,
      scheduleAgreementStatusText: POData?.scheduleAgreementStatusText,
      schrockenSAID: POData?.schrockenSAID,
      scheduleAgreementNumber: POData?.scheduleAgreementNumber,
      vendorName: POData?.vendorName,
      sponsorName: POData?.sponsorName,
      productsList: SLDetailsData?.SLDetails ? SLDetailsData?.SLDetails : [],
      poLineEditFlag: false,
      acceptOfferFlag: false,
      rejectOfferFlag: false,
      approveFlag: false,
      shareWithCMOFlag: false,
      confirmedFlag: false,
      SLDetails: null,
      approvalWorkFlowDetails: approvalWorkflowDetails.map((val) => {
        if (val.decisionBy === tokenData.email_address) {
          return {
            ...val,
            decision: type,
          };
        } else {
          return val;
        }
      }),
    };
    dispatch({
      type: OPEN_BACKDROP,
    });

    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updatePODetails`,
        data
      )
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          setAppoveRejectWorkflowSuccess({
            dialogBox: true,
            type: type,
          });
        } else {
          dispatch({
            type: DESTROY_BACKDROP,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        console.log(err);
      });
  };

  const handleClearFilters = () => {
    setProduct("all");
    setPOLineStatus("0");
    setRowsPerPage(5);
    setCurrentPage(1);
  };

  useEffect(() => {
    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllPOLineStatuses`
      )
      .then((res) => {
        if (res.data.status) {
          setPOLineStatusArray(
            res.data?.data?.poLineStatuses ? res.data?.data?.poLineStatuses : []
          );
        }
      })
      .catch((err) => console.log(err));

    let data = {
      schrockenSAID: SLDetailsData?.schrockenSAID,
      fgMaterialCode: selectProduct === "all" ? null : selectProduct,
      scheduleLineStatusID: parseInt(poLineStatus),
      pageNumber: currentPage,
      pageSize: noRowsPerPage,
    };
    setTableLoading(true);

    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOLineItems`,
        data
      )
      .then((res) => {
        if (res.data.status) {
          const fetchedData = res.data.data.SLDetails.map((item) => ({
            ...item,
          }));
          originalPOLineList.current = fetchedData; // Assign only after copying
          setPOLineList(fetchedData);
          setPOData(res.data.data.SADetails);
          setStatus(res.data.status);
          setApprovalWorkflowDetails(
            res.data.data.approvalWorkFlowData
              ? res.data.data.approvalWorkFlowData
              : []
          );
          setTotalPages(res.data.data.numberOfPages);
          setTableLoading(false);
          setPageLoading(false);
        } else {
          setStatus(false); // If API response is not successful
        }
      })
      .catch((err) => {
        console.log(err);
        setStatus(false);
      })
      .finally(() => {
        setTableLoading(false);
        setPageLoading(false);
      });
  }, [
    SLDetailsData?.schrockenSAID,
    selectProduct,
    poLineStatus,
    noRowsPerPage,
    currentPage,
  ]);

  return (
    <div>
      <BackDropLoading />
      <Grid container justifyContent="space-between">
        <Grid container item xs={12} md={6} className={classes.backGrid}>
          <div
            style={{
              display: "flex",
              alignSelf: "center",
              padding: "8px",
              cursor: "pointer",
            }}
            className={classes.backBtn}
            onClick={handleBack}
          >
            <ArrowBackIosIcon fontSize="small" />
            <Typography variant="body2">Back</Typography>
          </div>
        </Grid>
        <Grid item>
          {localStorage.collabType !== "CMO" ? (
            <>
              {POData?.scheduleAgreementStatusID === 21 ? (
                featuresAccess?.sharePOwithCMO && (
                  <Button
                    variant="contained"
                    color="primary"
                    disableElevation
                    disableRipple
                    disableFocusRipple
                    className={classes.styledBtn}
                    onClick={() =>
                      handleUpdatePOLineDetails("shareWithCMOFlag", null, [])
                    }
                  >
                    Share PO with CMO
                  </Button>
                )
              ) : POData?.scheduleAgreementStatusID === 23 &&
                POData?.poApprovedFlag ? (
                <Button
                  variant="contained"
                  color="primary"
                  disableElevation
                  disableRipple
                  disableFocusRipple
                  className={classes.styledBtn}
                // onClick={() => handleUpdatePOLineDetails("", null, [])}
                >
                  Inform CMO of PO changes
                </Button>
              ) : POData?.scheduleAgreementStatusID === 25 ? (
                featuresAccess?.approvePO && (
                  <Button
                    variant="contained"
                    color="primary"
                    disableElevation
                    disableRipple
                    disableFocusRipple
                    className={classes.styledBtn}
                    onClick={() =>
                      setConfirmPOApprove({
                        confirmDialogBox: true,
                        approveWorkflow: false,
                      })
                    }
                  >
                    Approve PO
                  </Button>
                )
              ) : POData?.scheduleAgreementStatusID === 26 &&
                approvalWorkflowDetails.filter(
                  (val) =>
                    val.decisionBy === tokenData.email_address &&
                    val.enableApprovalFlag === true
                ).length > 0 ? (
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={6}>
                    {featuresAccess?.approvePO && (
                      <Button
                        variant="contained"
                        style={{ backgroundColor: "#399438", color: "#fff" }}
                        disableElevation
                        disableRipple
                        disableFocusRipple
                        className={classes.styledBtn}
                        onClick={() => handleApproveRejectWorkflow("Approve")}
                      >
                        Approve
                      </Button>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    {featuresAccess?.rejectPO && (
                      <Button
                        variant="contained"
                        style={{ backgroundColor: "#FF0000", color: "#fff" }}
                        disableElevation
                        disableRipple
                        disableFocusRipple
                        className={classes.styledBtn}
                        onClick={() => handleApproveRejectWorkflow("Reject")}
                      >
                        Reject
                      </Button>
                    )}
                  </Grid>
                </Grid>
              ) : null}
            </>
          ) : POData?.scheduleAgreementStatusID === 23 &&
            POData?.poApprovedFlag &&
            localStorage.collabType === "CMO" ? (
            <Button
              variant="contained"
              color="primary"
              disableElevation
              disableRipple
              disableFocusRipple
              className={classes.styledBtn}
            // onClick={() => handleUpdatePOLineDetails("", null, [])}
            >
              Inform Sponsor of PO changes
            </Button>
          ) : null}
        </Grid>
      </Grid>
      {pageLoading ? (
        <div style={{ textAlign: "center", marginTop: "25%" }}>
          <CircularProgress color="primary" thickness={7} />
        </div>
      ) : status === false ? (
        <div
          style={{
            width: "80%",
            border: "2px solid rgb(255,0,0)",
            backgroundColor: "rgb(255,240,240)",
            Opacity: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "0.8rem",
            fontSize: "0.875rem",
            marginLeft: "8rem",
          }}
        >
          <Typography colSpan={10} align="center">
            Something went wrong. Please contact Schrocken Support.
          </Typography>
        </div>
      ) : (
        <React.Fragment>
          <TableContainer
            component={Paper}
            style={{ marginTop: "36px", boxShadow: "none" }}
          >
            <Table style={{ backgroundColor: "#f2f8fb" }}>
              <TableHead>
                <TableRow>
                  <TableCell style={{ border: "none" }} align="left">
                    PO Number
                  </TableCell>
                  {localStorage.collabType !== "CMO" ? (
                    <TableCell style={{ border: "none" }} align="left">
                      CMO Name
                    </TableCell>
                  ) : (
                    <TableCell style={{ border: "none" }} align="left">
                      Sponsor Name
                    </TableCell>
                  )}
                  <TableCell style={{ border: "none" }} align="left">
                    Date of Creation
                  </TableCell>
                  <TableCell style={{ border: "none" }} align="left">
                    Created By
                  </TableCell>
                  <TableCell style={{ border: "none" }} align="center">
                    PO Status
                  </TableCell>
                  <TableCell style={{ border: "none" }}>PO PDF</TableCell>
                  {featuresAccess?.viewPOHistory && (
                    <TableCell style={{ border: "none" }}></TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell align="left">
                    {presentFormatedData(POData?.scheduleAgreementNumber)}
                  </TableCell>
                  <TableCell align="left">
                    {localStorage.collabType !== "CMO"
                      ? presentFormatedData(POData?.vendorName)
                      : presentFormatedData(POData?.sponsorName)}
                  </TableCell>
                  <TableCell align="left">
                    {POData?.creationDate
                      ? moment(POData?.creationDate)
                        .format("DD-MMM-YYYY")
                        .toUpperCase()
                      : " - "}
                  </TableCell>
                  <TableCell align="left">
                    {presentFormatedData(POData?.createdBy)}
                  </TableCell>
                  <TableCell align="center">
                    {renderPOStatusButton(
                      POData?.scheduleAgreementStatusID,
                      POData?.scheduleAgreementStatusText
                    )}
                  </TableCell>
                  <TableCell align="left">
                    <a className={classes.clickableTextSty}>
                      Click here to download
                    </a>
                  </TableCell>
                  {featuresAccess?.viewPOHistory && (
                    <TableCell align="center">
                      <Button
                        onClick={handleViewHistory}
                        className={classes.button}
                      >
                        View PO History
                      </Button>
                    </TableCell>
                  )}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Grid
            container
            alignItems="flex-end"
            justifyContent="space-between"
            style={{ paddingTop: "1.5rem" }}
          >
            <Grid item xs={3} sm={3}>
              <Typography
                variant="body2"
                style={{
                  fontWeight: 500,
                  paddingRight: "8px",
                  paddingBottom: "8px",
                }}
              >
                Product Code / Name:
              </Typography>
              <FormControl style={{ minWidth: 120 }} fullWidth>
                <Select
                  value={selectProduct}
                  onChange={handleSelectProduct}
                  variant="outlined"
                  className={classes.selectFilterSty}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        height: productList.length > 1 ? "27%" : "8%",
                        overflowY: productList.length > 1 ? "scroll" : "hidden",
                      },
                    },
                  }}
                >
                  <MenuItem value="all">All</MenuItem>
                  {productList.map((val, index) => {
                    return (
                      <MenuItem key={index} value={val.fgMaterialCode}>
                        {val.fgMaterialCode} / {val.fgMaterialName}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} sm={3} style={{ paddingLeft: "10px" }}>
              <Typography
                variant="body2"
                style={{
                  fontWeight: 500,
                  paddingRight: "8px",
                  paddingBottom: "8px",
                }}
              >
                Line Status:
              </Typography>
              <FormControl style={{ minWidth: 120 }} fullWidth>
                <Select
                  value={poLineStatus}
                  onChange={handleSelectPOLineStatus}
                  variant="outlined"
                  className={classes.selectFilterSty}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        height: poLineStatusArray.length > 1 ? "27%" : "8%",
                        overflowY:
                          poLineStatusArray.length > 1 ? "scroll" : "hidden",
                      },
                    },
                  }}
                >
                  <MenuItem value="0">All</MenuItem>
                  {poLineStatusArray.map((status, index) => {
                    return (
                      <MenuItem key={index} value={status.statusID}>
                        {status.statusText}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} sm={3}>
              <Typography
                variant="caption"
                style={{ fontSize: 12, color: "blue", paddingLeft: "1rem" }}
                className={classes.clearText}
                onClick={handleClearFilters}
              >
                Clear Filters
              </Typography>
            </Grid>
            <Grid
              item
              xs={3}
              sm={3}
              className={clsx(classes.searchFld, classes.flxEd)}
              style={{ flexDirection: "column", alignItems: "end" }}
            >
              <div style={{ display: "flex" }}>
                <Typography variant="caption" className={clsx(classes.padR20)}>
                  {`Last synced @ ${moment(new Date()).format(
                    "HH:mm:ss; DD MMMM YYYY"
                  )}`}
                </Typography>

                <Typography
                  variant="caption"
                  color="primary"
                  onClick={handleRefresh}
                  className={classes.refreshSty}
                >
                  Refresh
                  <CachedIcon color="primary" style={{ fontSize: 15 }} />
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  paddingTop: "1rem",
                }}
              >
                <RowsPerPage value={noRowsPerPage} onChange={handleSetRows} />
              </div>
            </Grid>
          </Grid>

          <TableContainer
            component={Paper}
            style={{ marginTop: 20, maxHeight: 500 }}
          >
            <Table>
              <TableHead>
                <TableRow style={{ backgroundColor: "#F9F9FC" }}>
                  <TableCell align="left">Line</TableCell>
                  <TableCell align="left">Product Code / Description</TableCell>
                  <TableCell align="left">UoM</TableCell>
                  <TableCell align="left">Req. Qty</TableCell>
                  <TableCell align="left">Committed / Delivered Qty.</TableCell>
                  <TableCell align="left">Req. Date</TableCell>
                  <TableCell align="left">Committed / Delivery Date</TableCell>
                  <TableCell align="center">Line status</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableLoading === true && (
                  <TableRow style={{ height: 150 }}>
                    <TableCell colSpan={8}>
                      <div style={{ textAlign: "center" }}>
                        <CircularProgress color="primary" />
                      </div>
                    </TableCell>
                  </TableRow>
                )}
                {tableLoading === false && error !== "" && (
                  <TableRow
                    style={{
                      border: "2px solid #FF0000",
                      backgroundColor: "#FFF0F0",
                    }}
                  >
                    <TableCell colSpan={8} align="center">
                      Something went wrong. Please try again later.
                    </TableCell>
                  </TableRow>
                )}

                {tableLoading === false &&
                  error === "" &&
                  (POLineList.length > 0 ? (
                    POLineList.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell align="left">
                          {presentFormatedData(row.scheduleLineItemNumber)}
                        </TableCell>
                        <TableCell align="left">
                          {presentFormatedData(row.fgMaterialCode)}
                          {"/"}
                          <br />
                          {presentFormatedData(row.fgMaterialName)}
                        </TableCell>
                        <TableCell align="left">
                          {presentFormatedData(row.targetQuantityUOM)}
                        </TableCell>
                        <TableCell align="left">
                          {editableRow === index &&
                            localStorage.collabType !== "CMO" ? (
                            <TextField
                              variant="outlined"
                              type="number"
                              className={classes.textField}
                              value={row.requestedQuantity}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "requestedQuantity",
                                  Number(e.target.value)
                                )
                              }
                              size="small"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    {row?.requestedQuantity &&
                                      row?.availableQtyDetails?.availableQty ? (
                                      row?.requestedQuantity <=
                                        row?.availableQtyDetails?.availableQty ? (
                                        <CheckCircleIcon
                                          style={{ color: "#499F2A" }}
                                          fontSize="small"
                                        />
                                      ) : row?.requestedQuantity <=
                                        row?.availableQtyDetails
                                          ?.availableQtyWithRMPMPOs ? (
                                        <RemoveCircleIcon
                                          style={{ color: "#FFCC00" }}
                                          fontSize="small"
                                        />
                                      ) : (
                                        <CancelIcon
                                          style={{ color: "#FF0000" }}
                                          fontSize="small"
                                        />
                                      )
                                    ) : row?.requestedQuantity &&
                                      row?.availableQtyDetails?.availableQty ===
                                      0 ? (
                                      <CancelIcon
                                        style={{ color: "#FF0000" }}
                                        fontSize="small"
                                      />
                                    ) : null}
                                  </InputAdornment>
                                ),
                              }}
                            />
                          ) : (
                            row.requestedQuantity || "NA"
                          )}
                        </TableCell>
                        <TableCell align="left">
                          {editableRow === index &&
                            localStorage.collabType === "CMO" ? (
                            <TextField
                              variant="outlined"
                              type="number"
                              className={classes.textField}
                              value={row.committedQuantity}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "committedQuantity",
                                  Number(e.target.value)
                                )
                              }
                              size="small"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    {row?.committedQuantity &&
                                      row?.availableQtyDetails?.availableQty ? (
                                      row?.committedQuantity <=
                                        row?.availableQtyDetails?.availableQty ? (
                                        <CheckCircleIcon
                                          style={{ color: "#499F2A" }}
                                          fontSize="small"
                                        />
                                      ) : row?.committedQuantity <=
                                        row?.availableQtyDetails
                                          ?.availableQtyWithRMPMPOs ? (
                                        <RemoveCircleIcon
                                          style={{ color: "#FFCC00" }}
                                          fontSize="small"
                                        />
                                      ) : (
                                        <CancelIcon
                                          style={{ color: "#FF0000" }}
                                          fontSize="small"
                                        />
                                      )
                                    ) : row?.committedQuantity &&
                                      row?.availableQtyDetails?.availableQty ===
                                      0 ? (
                                      <CancelIcon
                                        style={{ color: "#FF0000" }}
                                        fontSize="small"
                                      />
                                    ) : null}
                                  </InputAdornment>
                                ),
                              }}
                            />
                          ) : (
                            row.committedQuantity || "NA"
                          )}
                        </TableCell>
                        <TableCell align="left">
                          {editableRow === index &&
                            localStorage.collabType !== "CMO" ? (
                            <CustomDatePickerMui
                              value={row.requestedDeliveryDate}
                              onChange={(date) =>
                                handleInputChange(
                                  index,
                                  "requestedDeliveryDate",
                                  date
                                )
                              }
                              minDate={new Date()}
                              notFullWidth
                            />
                          ) : row.requestedDeliveryDate ? (
                            moment(row.requestedDeliveryDate)
                              .format("DD-MMM-YYYY")
                              .toUpperCase()
                          ) : (
                            "NA"
                          )}
                        </TableCell>
                        <TableCell align="left">
                          {editableRow === index &&
                            localStorage.collabType === "CMO" ? (
                            <CustomDatePickerMui
                              value={row.committedDeliveryDate}
                              onChange={(date) =>
                                handleInputChange(
                                  index,
                                  "committedDeliveryDate",
                                  date
                                )
                              }
                              minDate={new Date()}
                              notFullWidth
                            />
                          ) : row.committedDeliveryDate ? (
                            moment(row.committedDeliveryDate)
                              .format("DD-MMM-YYYY")
                              .toUpperCase()
                          ) : (
                            "NA"
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {renderPOLineStatusButton(
                            presentFormatedData(row.scheduleLineStatusID),
                            presentFormatedData(row.scheduleLineStatusText)
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {editableRow === index
                            ? (() => {
                              let selectedLineitem;
                              if (row) {
                                selectedLineitem =
                                  originalPOLineList.current.filter(
                                    (val) =>
                                      val.schrockenSLID === row.schrockenSLID
                                  ).length > 0
                                    ? originalPOLineList.current.filter(
                                      (val) =>
                                        val.schrockenSLID ===
                                        row.schrockenSLID
                                    )[0]
                                    : {};
                              }

                              let changeInQty =
                                localStorage.collabType !== "CMO"
                                  ? row.requestedQuantity ===
                                    selectedLineitem.requestedQuantity
                                    ? false
                                    : true
                                  : row.committedQuantity ===
                                    selectedLineitem.committedQuantity
                                    ? false
                                    : true;

                              let changeInDate =
                                localStorage.collabType !== "CMO"
                                  ? row.requestedDeliveryDate &&
                                    selectedLineitem.requestedDeliveryDate
                                    ? isSameDate(
                                      row.requestedDeliveryDate,
                                      selectedLineitem.requestedDeliveryDate
                                    )
                                      ? false
                                      : true
                                    : row.requestedDeliveryDate
                                      ? true
                                      : false
                                  : row.committedDeliveryDate &&
                                    selectedLineitem.committedDeliveryDate
                                    ? isSameDate(
                                      row.committedDeliveryDate,
                                      selectedLineitem.committedDeliveryDate
                                    )
                                      ? false
                                      : true
                                    : row.committedDeliveryDate
                                      ? true
                                      : false;

                              return (
                                <div>
                                  {featuresAccess?.editRequiredQuantityAndDate && (
                                    <Button
                                      className={classes.saveEditButton}
                                      onClick={() => handleSaveClick(row)}
                                      disabled={!changeInQty && !changeInDate}
                                    >
                                      Save
                                    </Button>
                                  )}
                                </div>
                              );
                            })()
                            : localStorage.collabType !== "CMO"
                              ? row.scheduleLineStatusID === 21 ||
                                (row.scheduleLineStatusID === 23 &&
                                  POData?.scheduleAgreementStatusID === 21) ||
                                POData?.scheduleAgreementStatusID === 27 ||
                                ([23, 27].includes(
                                  POData?.scheduleAgreementStatusID
                                ) &&
                                  row?.scheduleLineStatusID === 25 &&
                                  POData?.poApprovedFlag)
                                ? featuresAccess?.editRequiredQuantityAndDate && (
                                  <Button
                                    className={classes.saveEditButton}
                                    onClick={() => handleEditClick(index)}
                                  >
                                    Edit
                                  </Button>
                                )
                                : (featuresAccess?.editRequiredQuantityAndDate ||
                                  featuresAccess?.acceptOffer ||
                                  featuresAccess?.deleteLineItem) && (
                                  <Actions
                                    enableCounterOffer={
                                      featuresAccess?.editRequiredQuantityAndDate &&
                                      [23, 24, 25].includes(
                                        row.scheduleLineStatusID
                                      )
                                    }
                                    enableRejectOffer={false}
                                    enableAcceptOffer={
                                      featuresAccess?.acceptOffer &&
                                      row.scheduleLineStatusID === 23 &&
                                      Boolean(row.committedQuantity) &&
                                      Boolean(row.committedDeliveryDate)
                                    }
                                    enableDeleteLineItem={
                                      featuresAccess?.deleteLineItem &&
                                      [23, 24, 25].includes(
                                        row.scheduleLineStatusID
                                      )
                                    }
                                    handleRatesDialog={() =>
                                      handleEditClick(index)
                                    }
                                    item={row}
                                    handleOpenProposeOfferDialog={
                                      handleOpenProposeOfferDialog
                                    }
                                    handleUpdatePOLineDetails={
                                      handleUpdatePOLineDetails
                                    }
                                  />
                                )
                              : [23, 27].includes(
                                POData?.scheduleAgreementStatusID
                              ) &&
                                row?.scheduleLineStatusID === 25 &&
                                POData?.poApprovedFlag
                                ? featuresAccess?.editRequiredQuantityAndDate && (
                                  <Button
                                    className={classes.saveEditButton}
                                    onClick={() => handleEditClick(index)}
                                  >
                                    Edit
                                  </Button>
                                )
                                : ![21].includes(row.scheduleLineStatusID) &&
                                  !(POData?.scheduleAgreementStatusID === 26)
                                  ? (featuresAccess?.editRequiredQuantityAndDate ||
                                    featuresAccess?.rejectLineItem ||
                                    featuresAccess?.acceptOffer) && (
                                    <Actions
                                      enableCounterOffer={
                                        featuresAccess?.editRequiredQuantityAndDate &&
                                        [23, 24, 25].includes(
                                          row.scheduleLineStatusID
                                        )
                                      }
                                      enableRejectOffer={
                                        featuresAccess?.rejectLineItem &&
                                        [23, 25].includes(row.scheduleLineStatusID)
                                      }
                                      enableAcceptOffer={
                                        featuresAccess?.acceptOffer &&
                                        [23, 24].includes(row.scheduleLineStatusID)
                                      }
                                      enableDeleteLineItem={false}
                                      handleRatesDialog={() =>
                                        handleEditClick(index)
                                      }
                                      item={row}
                                      handleOpenProposeOfferDialog={
                                        handleOpenProposeOfferDialog
                                      }
                                      handleUpdatePOLineDetails={
                                        handleUpdatePOLineDetails
                                      }
                                    />
                                  )
                                  : null}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        No Records Found
                      </TableCell>
                    </TableRow>
                  ))}
                {tableLoading === false && error !== "" && (
                  <TableRow
                    style={{
                      border: "2px solid #FF0000",
                      backgroundColor: "#FFF0F0",
                    }}
                  >
                    <TableCell colSpan={8} align="center">
                      Something went wrong. Please try again later.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            style={{ paddingTop: "1rem" }}
          >
            <PaginationInput
              totalPages={totalPages}
              handlePageChange={handlePageChange}
              page={currentPage}
            />
          </Grid>
        </React.Fragment>
      )}

      <Dialog
        open={successDialogBox.openDialogBox}
        disableBackdropClick // Disable closing on outside click
        disableEscapeKeyDown // Disable closing on escape key
        maxWidth="sm"
        fullWidth
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogContent className={classes.dialogContent}>
          <CheckCircleIcon className={classes.avatar} />
          <Typography
            style={{
              marginTop: "10px",
              fontWeight: "600",
              color: "black",
              fontSize: "2rem",
            }}
          >
            {successDialogBox.dialogBoxType === "updateLineItem"
              ? "Line item updated successfully"
              : successDialogBox.dialogBoxType === "shareWithCMO"
                ? "Details shared with CMO"
                : successDialogBox.dialogBoxType === "AcceptOffer" &&
                  localStorage.collabType !== "CMO"
                  ? "CMO offer accepted successfully"
                  : successDialogBox.dialogBoxType === "AcceptOffer" &&
                    localStorage.collabType === "CMO"
                    ? "Sponsor offer accepted successfully"
                    : successDialogBox.dialogBoxType === "RejectOffer"
                      ? "Sponsor offer rejected successfully"
                      : successDialogBox.dialogBoxType === "deleteLineItem"
                        ? "Line item deleted successfully"
                        : successDialogBox.dialogBoxType === "approvePO"
                          ? "PO approved successfully"
                          : successDialogBox.dialogBoxType === "ElectronicSignatureSuccess"
                            ? "Electronic Signature Applied Successfully"
                            : ""}
          </Typography>
          {successDialogBox.dialogBoxType === "approvePO" && (
            <Typography
              style={{
                marginTop: "10px",
                color: "black",
              }}
            >
              PO approval has been shared with CMO and SAP updated
            </Typography>
          )}
          <DialogActions className={classes.dialogActions}>
            <Button
              variant="contained"
              color="primary"
              endIcon={<ChevronRight />}
              style={{
                borderRadius: "20px",
                textTransform: "none",
              }}
              onClick={() => {
                if (
                  successDialogBox.dialogBoxType ===
                  "ElectronicSignatureSuccess"
                ) {
                  handleUpdateApproveRejectPOWorkflow(
                    successDialogBox?.decision === "Approve"
                      ? "Approved"
                      : successDialogBox?.decision === "Reject"
                        ? "Rejected"
                        : ""
                  );
                  setSuccessDialogBox({
                    openDialogBox: false,
                    dialogBoxType: "",
                  });
                } else {
                  handleRefresh();
                  setSuccessDialogBox({
                    openDialogBox: false,
                    dialogBoxType: "",
                  });
                }
              }}
            >
              {successDialogBox.dialogBoxType ===
                "ElectronicSignatureSuccess" &&
                successDialogBox?.decision === "Approve"
                ? "Approve PO"
                : successDialogBox.dialogBoxType ===
                  "ElectronicSignatureSuccess" &&
                  successDialogBox?.decision === "Reject"
                  ? "Reject PO"
                  : "Ok"}
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      {proposeOfferDialog.openDialogBox && (
        <ProposeCounterOfferDialog
          classes={classes}
          open={proposeOfferDialog.openDialogBox}
          onClose={handleCloseProposeOfferDialog}
          row={proposeOfferDialog.data}
          handleUpdatePOLineDetails={handleUpdatePOLineDetails}
        />
      )}

      <Dialog open={confirmPOApprove.confirmDialogBox} fullWidth>
        <DialogContent style={{ padding: "2rem" }}>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                setConfirmPOApprove({
                  confirmDialogBox: false,
                  approveWorkflow: false,
                });
              }}
            >
              Close <CloseIcon style={{ color: "#FF0000" }} fontSize="large" />
            </Typography>
          </Grid>
          <Typography
            variant="h5"
            style={{
              textAlign: "center",
              padding: "1rem",
              paddingBottom: "0px",
              fontWeight: 500,
              fontSize: "1.5rem",
            }}
          >
            Do you need any other approvals for changes to this PO?
            {/* Do you want to approve this PO? */}
          </Typography>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              textAlign: "center",
              padding: "1rem",
            }}
          >
            <Button
              variant="contained"
              disableElevation
              disableRipple
              disableFocusRipple
              className={classes.noButton}
              onClick={() => {
                handleUpdatePOLineDetails("approveFlag", null, []);
                setConfirmPOApprove({
                  approveWorkflow: false,
                  confirmDialogBox: false,
                });
              }}
            >
              No
            </Button>
            <StyledButton
              style={{ paddingLeft: "3rem", paddingRight: "3rem" }}
              disabled={true}
              onClick={() => {
                // setConfirmPOApprove({
                //   approveWorkflow: true,
                //   confirmDialogBox: false,
                // });
                // handleUpdatePOLineDetails("approveFlag", null, []);
                // setConfirmPOApprove({
                //   approveWorkflow: false,
                //   confirmDialogBox: false,
                // });
              }}
            >
              Yes
            </StyledButton>
          </Grid>
        </DialogContent>
      </Dialog>

      {confirmPOApprove.approveWorkflow && (
        <DraggableDialogTable1
          open={confirmPOApprove.approveWorkflow}
          handleClose={() => {
            setConfirmPOApprove({
              confirmDialogBox: false,
              approveWorkflow: false,
            });
          }}
          poDetails={POData}
        // handleReviewApproveSuccess={}
        />
      )}

      {electronicSignatureDialog.electronicSignatureValidation && (
        <ElectronicSignatureValidation
          open={electronicSignatureDialog.electronicSignatureValidation}
          onClose={() => {
            setElectronicSignatureDialog({
              electronicSignatureValidation: false,
              electronicSignatureSuccess: false,
              data: null,
            });
          }}
          poDetails={electronicSignatureDialog.data}
          handleESignatureSuccess={() => {
            setSuccessDialogBox({
              openDialogBox: true,
              dialogBoxType: "ElectronicSignatureSuccess",
              decision: electronicSignatureDialog.data.decision,
            });
            setElectronicSignatureDialog({
              ...electronicSignatureDialog,
              electronicSignatureValidation: false,
              electronicSignatureSuccess: false,
            });
          }}
        />
      )}

      <Dialog open={approveRejectWorkFlowSuccess.dialogBox} fullWidth>
        <StyledDialog
          icons={true}
          handleClose={() => {
            setAppoveRejectWorkflowSuccess({
              dialogBox: false,
              type: "",
            });
          }}
          title={
            approveRejectWorkFlowSuccess.type === "Approved"
              ? "PO approved successfully"
              : "PO rejected successfully"
          }
        />
      </Dialog>
      {POData?.scheduleAgreementNumber && featuresAccess?.chatforPO && (
        <ChatBox
          poNumber={POData?.scheduleAgreementNumber}
          vendorMosymphonyID={POData?.vendorMosymphonyID}
        />
      )}
    </div>
  );
};

export default POLineItemDashboard;
